const UserListIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{flexShrink: 0}}
    >
      <path
        d="M3.17543 10.0602C2.41401 10.5209 0.417609 11.4616 1.63355 12.6387C2.22753 13.2138 2.88907 13.625 3.72078 13.625H8.46672C9.29843 13.625 9.95997 13.2138 10.5539 12.6387C11.7699 11.4616 9.77349 10.5209 9.01207 10.0602C7.22655 8.97992 4.96095 8.97992 3.17543 10.0602Z"
        stroke="#141B34"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.4375 4.875C8.4375 6.25571 7.31821 7.375 5.9375 7.375C4.55679 7.375 3.4375 6.25571 3.4375 4.875C3.4375 3.49429 4.55679 2.375 5.9375 2.375C7.31821 2.375 8.4375 3.49429 8.4375 4.875Z"
        stroke="#141B34"
      />
      <path
        d="M10.625 3.625L13.75 3.625"
        stroke="#141B34"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.625 5.5L13.75 5.5"
        stroke="#141B34"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 7.375L13.75 7.375"
        stroke="#141B34"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UserListIcon;
